import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useContext, useEffect, useState } from "react";
import CampaignContext from "../../../contexts/CampaignContext";
import restService from "../../../restService";
import UserContext from "../../../contexts/UserContext";
import produce from "immer";
import { PulseLoader } from "react-spinners";

export const regions = [
  "Ahafo Region",
  "Ashanti Region",
  "Bono East",
  "Brong Ahafo",
  "Eastern Region",
  "Greater Accra Region",
  "North East Region",
  "Northern Region",
  "Savannah Region",
  "Upper East Region",
  "Upper West Region",
  "Western Region",
  "Western North Region",
  "Volta Region",
  "Oti Region",
  "Central Region",
];

const EditStation = () => {
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);

  const [stationFormData, setStationFormData] = useState({
    stationName: "",
    zone: "",
    region: "",
    agentPhone: [],
    stationPhone: "",
  });

  const [stationId, setStationId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    retrieveStationDetails(id);
  }, []);

  const retrieveStationDetails = async (id) => {
    setLoading(true);

    try {
      const {
        data: { data },
      } = await restService.Management.getStationById(campaign.id, id);

      await stationForm.setFieldValue("stationName", data?.location);
      await stationForm.setFieldValue("zone", data?.zone);
      await stationForm.setFieldValue("region", data?.region);
      await stationForm.setFieldValue("agentPhone", data?.agents);
      setStationFormData({
        ...stationFormData,
        region: data?.region,
        stationName: data?.location,
        stationPhone: data?.agentMsisdn,
        zone: data?.zone,
        agentPhone: data?.agents,
      });
      await stationForm.setFieldValue("stationPhone", data?.agentMsisdn);
      setStationId(data?.stationId);

      console.log(data);

      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const onEditStation = async (values) => {
    setIsSaving(true);

    try {
      const editedStation = {
        name: values.stationName,
        location: values.stationName,
        zone: values.zone,
        agentMsisdn: values.agentPhone,
        region: values.region,
        campaignId: campaign.id,
      };

      await restService.Management.editStation(
        user.accessToken,
        campaign.id,
        stationId,
        editedStation
      );

      navigate(-1);
    } catch (error) {
      console.log(error);
      setIsSaving(false);
    }
  };

  const stationForm = useFormik({
    initialValues: {
      stationName: "",
      stationPhone: "",
      zone: "",
      region: "",
      agentPhone: [],
    },
    validationSchema: Yup.object({
      stationName: Yup.string().required("Station location is required"),
      stationPhone: Yup.string()
        .required("Station phone is required")
        .matches(/^[0-9]+$/, "Must be only digits")
        .length(12, "Phone number must start with 233 & be 12 digits"),
      zone: Yup.string().required("Station zone is required"),
      region: Yup.string().required("Agent name is required"),
      agentPhone: Yup.array(),
      // .required("Station phone is required")
      // .matches(/^[0-9]+$/, "Must be only digits")
      // .length(12, "Phone number must start with 233 & be 12 digits"),
    }),
    onSubmit: onEditStation,
  });

  return (
    <div className=" h-full md:mb-8 md:pb-8 px-4 w-full md:px-12">
      <div>
        <div className="flex items-center">
          <button className="mr-6" onClick={() => navigate(-1)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
          </button>
          <h1 className="text-xl">Stations / Edit Station</h1>
        </div>
      </div>

      <div className=" h-auto pb-8   my-8 w-full">
        <div className="bg-white h-auto mb-12 ring-1 ring-gray-200 rounded-md shadow-[0_0_10px_-3px_rgba(0,0,0,0.2)]">
          {loading ? (
            <div className="  flex items-center justify-center">
              <PulseLoader color="#FF6A3A" />
            </div>
          ) : (
            <form
              className="p-8 h-full flex flex-col gap-11"
              onSubmit={(e) => {
                e.preventDefault();
                onEditStation(stationFormData);
              }}
            >
              <div className="">
                <div className="md:grid md:grid-cols-3 md:gap-16 ">
                  <div className="my-4">
                    <label htmlFor="stationName">
                      <p className="py-1 after:content-['*'] after:ml-1.5 after:text-red-500">
                        Station Location
                      </p>
                      <input
                        placeholder="Enter Station Name"
                        name="stationName"
                        onChange={(e) => {
                          const value = e.target.value;

                          setStationFormData({
                            ...stationFormData,
                            stationName: value,
                          });
                        }}
                        // onBlur={stationForm.handleBlur}
                        value={stationFormData.stationName}
                        className="w-full border border-gray-300 px-3 pr-8 invalid:border-red-500
                            invalid:text-red-600 focus:invalid:border-red-500 focus:invalid:ring-red-500
                            py-1.5 rounded-md focus:outline-none"
                      />
                      {stationForm.errors.stationName &&
                        stationForm.touched.stationName && (
                          <p className="mt-1 text-red-400 text-xs">
                            {stationForm.errors.stationName}
                          </p>
                        )}
                    </label>
                  </div>
                  <div className="my-4">
                    <label htmlFor="stationPhone">
                      <p className="py-1 after:content-['*'] after:ml-1.5 after:text-red-500">
                        Station Phone Number
                      </p>
                      <input
                        placeholder="Station Phone ( 233 XX XXX XXXX ) "
                        name="stationPhone"
                        onChange={(e) => {
                          const value = e.target.value;

                          setStationFormData({
                            ...stationFormData,
                            stationPhone: value,
                          });
                        }}
                        type={"number"}
                        value={stationFormData.stationPhone}
                        // onBlur={stationForm.handleBlur}
                        className="w-full border border-gray-300 px-3 pr-8 invalid:border-red-500
                            invalid:text-red-600 focus:invalid:border-red-500 focus:invalid:ring-red-500
                            py-1.5 rounded-md focus:outline-none"
                      />
                      {stationForm.errors.stationPhone &&
                        stationForm.touched.stationPhone && (
                          <p className="mt-1 text-red-400 text-xs">
                            {stationForm.errors.stationPhone}
                          </p>
                        )}
                    </label>
                  </div>
                  <div className="my-4">
                    <label htmlFor="zone">
                      <p className="py-1 after:content-['*'] after:ml-1.5 after:text-red-500">
                        Zone
                      </p>
                      <input
                        placeholder="Enter Station Zone"
                        name="zone"
                        // onBlur={stationForm.handleBlur}
                        onChange={(e) => {
                          const value = e.target.value;

                          setStationFormData({
                            ...stationFormData,
                            zone: value,
                          });
                        }}
                        value={stationFormData.zone}
                        className="w-full border border-gray-300 px-3 invalid:border-red-500
                            invalid:text-red-600 focus:invalid:border-red-500 focus:invalid:ring-red-500
                           pr-8 py-1.5 rounded-md focus:outline-none"
                      />
                      {stationForm.errors.zone && stationForm.touched.zone && (
                        <p className="mt-1 text-red-400 text-xs">
                          {stationForm.errors.zone}
                        </p>
                      )}
                    </label>
                  </div>
                </div>
              </div>

              <div className="">
                <div className="py-1.5">
                  <p className="text-xl ">Assign Agent</p>
                </div>
                <div className=" flex flex-col md:gap-8 ">
                  <div className=" md:w-2/5">
                    <p className="py-1 after:content-['*'] after:ml-1.5 after:text-red-500">
                      Region
                    </p>
                    <label htmlFor="region" className="relative block">
                      {/* <span className="absolute inset-y-0 right-0 flex items-center pr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-[#848484]"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span> */}
                      <label htmlFor="region">
                        <select
                          placeholder="Enter Station Name"
                          name="region"
                          id="region"
                          onChange={(e) => {
                            const value = e.target.value;

                            setStationFormData({
                              ...stationFormData,
                              region: value,
                            });
                          }}
                          value={regions.find((x) =>
                            x
                              ?.toLocaleLowerCase()
                              .includes(
                                stationFormData?.region?.toLocaleLowerCase()
                              )
                          )}
                          className="w-full border border-gray-300 px-3 pr-8 invalid:border-red-500 appearance-none
                            invalid:text-red-600 focus:invalid:border-red-500 focus:invalid:ring-red-500
                            py-1.5 rounded-md focus:outline-none"
                        >
                          <option value="" />

                          {regions.map((region, index) => (
                            <option key={index} value={region}>
                              {region}
                            </option>
                          ))}
                        </select>
                      </label>
                      {stationForm.errors.region &&
                        stationForm.touched.region && (
                          <p className="mt-1 text-red-400 text-xs">
                            {stationForm.errors.region}
                          </p>
                        )}
                    </label>
                  </div>

                  <div>
                    <p className="py-1 after:content-['*'] after:ml-1.5 after:text-red-500">
                      Agents Phone Number
                    </p>
                    <div className="md:grid md:grid-cols-3 md:gap-8 ">
                      {stationFormData?.agentPhone?.map((item, index) => (
                        <div key={index} className="">
                          <label htmlFor="agentPhone">
                            <div className="flex items-center gap-2">
                              <input
                                placeholder="Agent Phone ( 233 XX XXX XXXX ) "
                                required
                                type={"number"}
                                name="agentPhone"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  // use produce to update the state
                                  setStationFormData(
                                    produce((draft) => {
                                      draft.agentPhone[index].msisdn = value;
                                    })
                                  );
                                }}
                                value={item.msisdn}
                                className="w-full border border-gray-300 px-3 pr-8 invalid:border-red-500
                            invalid:text-red-600 focus:invalid:border-red-500 focus:invalid:ring-red-500
                            py-1.5 rounded-md focus:outline-none"
                              />
                              <span
                                onClick={() => {
                                  setStationFormData(
                                    produce((draft) => {
                                      draft.agentPhone.splice(index, 1);
                                    })
                                  );
                                }}
                                className="rounded-full h-5 font-bold cursor-pointer hover:bg-[#c1030335] transition bg-[#ff00001a] text-[#ff0000] w-5 text-xs flex items-center justify-center"
                              >
                                X
                              </span>
                            </div>
                            {stationForm.errors.agentPhone &&
                              stationForm.touched.agentPhone && (
                                <p className="mt-1 text-red-400 text-xs">
                                  {stationForm.errors.agentPhone}
                                </p>
                              )}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="">
                {isSaving ? (
                  <button
                    disabled
                    className="py-2 hover:bg-blue-50 hover:border-blue-500 hover:border-2 hover:text-blue-500 hover:font-bold  px-16 rounded-md text-white bg-blue-500"
                  >
                    Saving...
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="py-2 hover:bg-blue-50 hover:border-blue-500 hover:border-2 hover:text-blue-500 hover:font-bold  px-16 rounded-md text-white bg-blue-500"
                  >
                    Save
                  </button>
                )}
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditStation;
